"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const CardTitle_vue_1 = __importDefault(require("./CardTitle.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'OpeningHours',
    props: {
        days: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", null, [
                (0, vue_2.createVNode)(CardTitle_vue_1.default, { title: "Nyitva tartás" }),
                (0, vue_2.createElementVNode)("table", null, [
                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(_ctx.days, (day, index) => {
                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", { key: index }, [
                            (0, vue_2.createElementVNode)("td", null, (0, vue_2.toDisplayString)(day.dayName), 1),
                            (0, vue_2.createElementVNode)("td", null, (0, vue_2.toDisplayString)(day.open), 1)
                        ]));
                    }), 128))
                ])
            ]));
        };
    }
});
